import objectPath from 'object-path'

const getRuleClearActiveTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleClearActiveStatus = (status = {}) => {
  let { isDynamic, dynamicName, dynamicKey, dynamicIndex } = status

  return {
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
  }
}

export const onRuleClearActive = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let targetKey = getRuleClearActiveTarget(action, target)
  if (!targetKey) return undefined

  objectPath.set(isUiChanged, targetKey, {
    isClearActive: true,
    ...getRuleClearActiveStatus(status),
  })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: targetKey,
    isClearActive: true,
  }
}
